import React from 'react'

import { BCol, BRow } from '@prague-digi/ui-components'
import classNames from '@prague-digi/class-names'

import tickDone from '../../assets/tickDone.svg'
import styles from './styles.scss'

interface Props {
  children: any
  noMargin?: boolean
  small?: boolean
  className?: any
  large?: boolean
}

export const InfoCheckbox: React.FC<Props> = (props: Props) => {
  const theme = classNames({
    [styles.noMargin]: !!props.noMargin,
    [props.className]: !!props.className,
  })

  const iconContainerTheme = classNames(
    'col-auto',
    'pr-0',
    'd-flex',
    'align-items-start',
    styles.iconContainer,
    {
      [styles.small]: !!props.small,
      [styles.large]: !!props.large,
    }
  )

  return (
    <BRow theme={theme}>
      <BCol theme={iconContainerTheme}>
        <img src={tickDone} alt="*" />
      </BCol>
      <BCol>{props.children}</BCol>
    </BRow>
  )
}

export default InfoCheckbox
